/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoyaltyApiModel } from './loyalty';

export interface FeedbackSourceApiModel {
  /**
   * Allow add picture to the feddback flag
   */
  allow_pictures?: number;
  /**
   * Allow add picture to the feddback flag
   */
  allow_video?: number;
  /**
   * Allow add picture to the feddback flag
   */
  allow_voice?: number;
  /**
   * Allowed/required customers action
   */
  customer_actions?: FeedbackSourceApiModelCustomerActionsEnum;
  /**
   * Feedback source ID
   */
  id?: string;
  /**
   * Text displayed for customers as invitation
   */
  invitation_text?: string;
  loyalty?: LoyaltyApiModel;
  /**
   * Title
   */
  title?: string;
}
export enum FeedbackSourceApiModelCustomerActionsEnum {
  RateOnly = 'rate-only',
  ReviewOnly = 'review-only',
  RateOrReview = 'rate-or-review',
  RateAndReview = 'rate-and-review'
}
